module.exports = __webpack_public_path__ + "img/img89.b0df1884.svg";